import { render, staticRenderFns } from "./FranchiseCourseView.vue?vue&type=template&id=ef42752a"
import script from "./FranchiseCourseView.vue?vue&type=script&lang=js"
export * from "./FranchiseCourseView.vue?vue&type=script&lang=js"
import style0 from "./FranchiseCourseView.vue?vue&type=style&index=0&id=ef42752a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports